export default "__VITE_ASSET__CT0pU$UO__"